module.exports = __webpack_public_path__ + "static/erika-rentmeesters-e82c790890ac1c5fe52e0447d0e64aa3.jpg";